import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Koryu extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - Koryu No Mimi - English Translation v2.0 SNES
            Kouryuu No Mimi 黄龍の耳 (Golden Dragons Ear)
          </title>
          <meta
            name="title"
            content="RPGONE Translations - Koryu No Mimi - English Translation v2.0 SNES Kouryuu No Mimi 黄龍の耳 (Golden Dragons Ear)"
          />
          <meta
            name="description"
            content="Kouryuu No Mimi Snes English Translation v2.0 - Natsume Kiroemon, the 45th leader of the Natsume family, is due to inherit the Koryu No Mimi, also known as the Golden Dragon Ring, which gives its bearer easy access to wealth and women - Koryu No Mimi for the SNES / Super Famicom / Super Nintendo by RPGONE Translations"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                {/*<h3>Koryu No Mimi - English Translation</h3>
            <i><div>黄龍の耳 - "Golden Dragons Ear"</div></i>*/}
              </span>
              <div className="center-image">
                <img
                  src={require("./img/koryu_00000_title_score.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00009.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00015.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00029.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00042.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00037.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00002.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/koryu_00012.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    Koryu No Mimi - Golden Dragons Ear - Kouryuu No Mimi<br />Original
                    release: 22nd December 1995 on Super Famicom (Snes / Super
                    Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              Natsume Kiroemon, the 45th leader of the Natsume family, is due to
              inherit the Koryu No Mimi, also known as the Golden Dragon Ring,
              which gives its bearer easy access to wealth and women. As a
              result of his father's death, he left the Italian monastery where
              he'd been training and rightfully took the name "Natsume Kiroemon"
              as well as the power of the Golden Dragon Ring.<br />
              <br />
              Upon his return to Japan, Kiroemon fell fatally in love with
              Kanako, one of the members of the rival Mina clan. However, the
              evil hand of the Mina clan attacked Kiroemon and then abducted
              Kanako. Now Kiroemon has unsealed the power of the Golden Dragon
              Ring, making his own power surge, and he's striking back at the
              Mina clan. Both Kiroemon and Kanako's fate are in your hands!
              <br />
              <br />
              <div className="center-image">
                <a href={require("./img/box/Koryu No Mimi - Box Cover.jpg")}>
                  <img
                    src={require("./img/box/Koryu No Mimi - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./img/box/Koryu No Mimi - Box Back.jpg")}>
                  <img
                    src={require("./img/box/Koryu No Mimi - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Character Bios</div>
              </b>
              <br />
              <b>Natsume Kiroemon</b>
              <br />
              The 45th leader of the Natsume family and heir of the "Koryu No
              Mimi", a tool which gives its bearer easy access to wealth and
              women. After the death of his father, he takes the name "Natsume
              Kiroemon" as well as the power of the Koryu No Mimi, also known as
              the Golden Dragon Ring. Then he falls fatally in love with Kanako,
              a member of the rival Mina clan. Kiroemon, with a father from the
              Natsume family and a mother from the Mina clan, now rightfully
              wields the power of the Golden Dragon Ring, which has been
              masterless since his father's passing.<br />
              <br />
              <b>Kanako Shijou</b>
              <br />
              The Mina clan, whose history with the Natsume family goes back at
              least 1000 years, has started using the female body to confuse and
              control men. This is the family Kanako belongs to. She rebels
              against them, refusing a political marriage of convenience to
              Ichirou Souma, and flees to a church where she has a pre-destined
              encounter with Kiroemon. After proving their love to each other,
              Kanako returns to her clan because she feels that being with
              Kiroemon will only further the feuding between their families.<br />
              <br />
              <b>Sinclaire Gordon</b>
              <br />
              Part of the staff of the Gordon Law Office, a group who works for
              the Natsume family from behind the scenes taking care of legal
              matters like wills and estates. In order to function as Kiroemon's
              personal bodyguard, her shooting skills are top notch, and she's
              well-versed in all forms of hand-to-hand combat. She fearlessly
              takes on all the troublesome enemies that attack Kiroemon.
              Kiroemon is still very young, so he's got to have a partner.<br />
              <br />
              <i>Character Bios from SFC game manual</i>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Koryu No Mimi - English v2.0.zip")}
                download="Koryu No Mimi - English v2.0.zip"
              >
                English Translation patch v2.0
              </a>{" "}
              by RPGONE
              <br />
              <br />
              <a href="http://terminus.romhack.net/index.php?page=jv&projet=KouryuNoMimiFr">
                French Translation patch v2.0
              </a>{" "}
              by FlashPV
              <br />
              <br />
 	      <a href="https://traduccionessemco.blogspot.com/2018/06/traduccion-de-kouryuu-no-mimi-v-20-snes.html">
                Spanish Translation patch v2.0
              </a>{" "}
              by Semco
              <br />
              <br />
              <a
                href={require("./files/Koryu No Mimi - Cheat patch.zip")}
                download="Koryu No Mimi - Cheat patch.zip"
              >
                Infinite Health Cheat patch
              </a>{" "}
              (Works on the English translation and also the original Japanese
              rom)<br />
              Press Select in-game for infinite Health, infinite Koryu Power and
              infinite Weapon use.<br /> Press Start+Select in-game again to
              disable it
              <br />
              <br />
              <a href="http://www.romhacking.net/translations/852/">
                Project page on romhacking.net
              </a>
              <br />
              <br />
              Review:{" "}
              <a href="http://retrovania-vgjunk.blogspot.com/2012/08/kouryuu-no-mimi-snes.html">
                http://retrovania-vgjunk.blogspot.com/2012/08/kouryuu-no-mimi-snes.html
              </a>
              <br />
              <br />
              <div className="center-image">
                Moves list from the game manual - Attack / Combos<br />{" "}
                <a href={require("./files/Koryu Attacks.jpg")}>
                  <img
                    src={require("./files/Koryu Attacks.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./files/Koryu Combos.jpg")}>
                  <img
                    src={require("./files/Koryu Attacks.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
                <br />
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <b>7E0500 XX - Play as enemy characters</b> (only works for the
              enemies on the current stage)<br />
              <span className="parCode-padding" />04 - Stage 1 Biker<br />
              <span className="parCode-padding" />05 - Stage 1 Naomi<br />
              <span className="parCode-padding" />08 - Stage 2 Gang member<br />
              <span className="parCode-padding" />0C - Stage 2 Souma<br />
              <span className="parCode-padding" />etc<br />
              <br />
              <b>7E019402 - Skip through all the levels</b> - useful if you only
              want to read the dialog text and not play the game.<br />
              Change to 00 to play the level<br />
              <br />
              <code-container>
                <row-section>
                  <b>7E007E</b>
                </row-section>
                <row-section>
                  <b>XX</b>
                </row-section>
                <row-section>
                  <b>- Change the Level</b>
                </row-section>

                <row-section />
                <row-section-leftpadding>00</row-section-leftpadding>
                <row-section>- Stage 1-1</row-section>

                <row-section />
                <row-section-leftpadding>04</row-section-leftpadding>
                <row-section>- Stage 2-1</row-section>

                <row-section />
                <row-section-leftpadding>08</row-section-leftpadding>
                <row-section>- Stage 3-1</row-section>

                <row-section />
                <row-section-leftpadding>10</row-section-leftpadding>
                <row-section>- Stage 4-1</row-section>

                <row-section />
                <row-section-leftpadding>13</row-section-leftpadding>
                <row-section>- Stage 5-1</row-section>

                <row-section />
                <row-section-leftpadding>15</row-section-leftpadding>
                <row-section>- Ending text and Credits</row-section>
              </code-container>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Japanese Prototype Screenshots</div>
              </b>
              <br />
              The SFC game manual has some screenshots from a prototype version
              of the game.<br />
              <br />
              Sinclaire Gordon's outfit was originally purple, but was later
              changed to orange. This was a good change as the purple color was
              way too similar to Kiroemon's outfit.<br />
              <div className="center-image">
                <b>Left is from the manual, right is released Japanese game</b>
                <br />
                <img
                  src={require("./img/proj/koryubeta1.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/proj/koryufinal1.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              Kiroemon's portrait in the status bar was also changed before
              release.<br />
              <div className="center-image">
                <b>Left is from the manual, right is released Japanese game</b>
                <br />
                <img
                  src={require("./img/proj/koryubeta2.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/proj/koryufinal2.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              Sinclaire Gordon's portrait was changed slightly before release
              too.
              <br />
              Note the portrait image space is wider, and that the frame is
              different, in the beta and the released version.
              <br />
              <div className="center-image">
                <b>Left is from the manual, right is released Japanese game</b>
                <br />
                <img
                  src={require("./img/proj/koryubeta3.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/proj/koryufinal3.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Game Development Credits</div>
              </b>
              <br />
              <b>Credits スタツフ</b> <br />
              <br />
              <b>Original Concept 原作</b> <br />
              <span className="parCode-padding" />Oosawa Arimasa 大沢在昌 <br />
              <b>Script 脚本 </b>
              <br />
              <span className="parCode-padding" />M.A.T Ｍ・Ａ・Ｔ <br />
              <b>Visual Artwork 作画 </b>
              <br />
              <span className="parCode-padding" />Inoue Noriyoshi 井上紀良{" "}
              <br />
              <span className="parCode-padding" />Series in "Young Jump Weekly"
              （集英社「週刊ヤングジャンプ」連載）<br />
              <b>Design Partners 企画協力 </b>
              <br />
              <span className="parCode-padding" />Fine Entertainment Co.
              （株）ファイン・インタ‐ナショナルプロダクツ <br />
              <span className="parCode-padding" />Furuki Mitsuhara 古木光春{" "}
              <br />
              <span className="parCode-padding" />Kimura Hiroyuki 木村宏行{" "}
              <br />
              <span className="parCode-padding" />"Young Jump" Editors
              集英社ヤングジャンプ編集部 <br />
              <b>Game Design ゲ‐ム企画 </b>
              <br />
              <span className="parCode-padding" />Okazaki Atsushi 岡崎厚詞{" "}
              <br />
              <b>Programming プログラム </b>
              <br />
              <span className="parCode-padding" />Yoshikawa Satoshi 吉川聡{" "}
              <br />
              <span className="parCode-padding" />Kouno Yujin 河 野友仁 <br />
              <b>Graphics グラフイツク </b>
              <br />
              <span className="parCode-padding" />Mashiko Hiromi 益子宏美 <br />
              <span className="parCode-padding" />Sasaki Noritoshi 佐々木徳俊{" "}
              <br />
              <span className="parCode-padding" />Sasakiai Yuuko 榊愛由子 <br />
              <span className="parCode-padding" />Ishii Yuri 石井由利 <br />
              <b>Sound Programming/SFX サウンド プログラム・効果音 </b>
              <br />
              <span className="parCode-padding" />Tadashi Seikou 禎清宏音 <br />
              <b>Music 音楽 </b>
              <br />
              <span className="parCode-padding" />Takada Youko 高田陽子 <br />
              <b>Special Thanks スペシャル サンクス </b>
              <br />
              <span className="parCode-padding" />Hotta Masahiko 堀田政彦 <br />
              <span className="parCode-padding" />Sekimoto Takayuki 関本貴之{" "}
              <br />
              <span className="parCode-padding" />Okamoto Shigeru 岡本茂 <br />
              <span className="parCode-padding" />Ohira Hiroshi 大平浩 <br />
              <span className="parCode-padding" />Kobayashi Tomoko 小林智子{" "}
              <br />
              <span className="parCode-padding" />Itou Muga 伊藤無我 <br />
              <b>Producers プロデュ‐ス </b>
              <br />
              <span className="parCode-padding" />Nanami Youichi (VAP) 七海洋一
              （ＶＡＰ） <br />
              <span className="parCode-padding" />Inada Kiyoto (VAP) 稲田清人
              （ＶＡＰ） <br />
              <b>Production 製作 著作 </b>
              <br />
              <span className="parCode-padding" />VAP Co. (株)バップ <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Koryu);



// WEBPACK FOOTER //
// ./src/Koryu.js